import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';
import FormSection from '../../../components/FormSection';
import MediaSection from '../../media/MediaSection';
import type { MediaLocation } from '../../media/mediaFileName';
import type { SketchStrata } from '../sketchStrata';

/**
 * The description's photos and sketches — or, before the first save, the reason
 * there are none: media hang off the record id, which does not exist yet.
 */
export default function MediaSectionBox({
    projectId,
    ownerType,
    ownerId,
    canEdit,
    location,
    onSketchStrata,
    strataTool,
    onNavigate
}: {
    projectId: string;
    ownerType:
        | 'findingPlanum'
        | 'findingProfile'
        | 'overallDescription'
        | 'areaDescription'
        | 'sample'
        | 'diary';
    /** Null while the description is unsaved. */
    ownerId: string | null;
    canEdit: boolean;
    /** Gesb./Befund, Fläche, Planum bzw. Profil — what a download is named after. */
    location?: MediaLocation;
    /** The Schichten drawn on the sketches — they seed the Maße's list. */
    onSketchStrata?: (sketches: SketchStrata[]) => void;
    /** Whether the sketch editor offers its Schichten tool (see MediaSection). */
    strataTool?: boolean;
    /** The dialog's guarded navigate, for the "auch in …" links. */
    onNavigate?: (to: string) => void;
}) {
    return (
        <FormSection anchorId="media">
            {ownerId ? (
                // The section renders its own header row, the add-photo/sketch
                // buttons sitting in it.
                <MediaSection
                    projectId={projectId}
                    ownerType={ownerType}
                    ownerId={ownerId}
                    canEdit={canEdit}
                    location={location}
                    titleVariant="h6"
                    onSketchStrata={onSketchStrata}
                    strataTool={strataTool}
                    onNavigate={onNavigate}
                />
            ) : (
                <>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        <FormattedMessage id="media.title" />
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                    >
                        <FormattedMessage id="media.saveFirst" />
                    </Typography>
                </>
            )}
        </FormSection>
    );
}
